import Header from "../../Components/Header"
import { useContext, useEffect } from "react";
import { StateContext } from "../../services/context";
import { useNavigate } from "react-router";
import { DeleteDocumentModal } from "../../Components/Modals/Documents/DeleteDocumentModal";
import { DeleteAllDocumentModal } from "../../Components/Modals/Documents/DeleteAllDocumentsModal";
import { useState } from "react";
import { DocumentData } from "../../utils/state";
import { api } from "../../services/POST";
import { DocumentCard, NewDocumentCard } from "../../Components/DocumentComopnents";
import { LeftArrowIcon, DeleteIcon } from "../../utils/iconFactory";
import HelperModal, { HelperButton } from "../../Components/HelperComponents";
import { DocumentDownlaoder, copyDocumentData } from "../../Components/DocumentServices";
import { TertiaryGrayButton } from "../../Components/Elements/CustomButtons";
import { SubscriptionModal } from "../../Components/Modals/SubscriptionModal";

export default function Documents() {
  const {user, setLoadedDocument, showPopup} = useContext(StateContext)
  const navigate = useNavigate();

  const [loadedDocuments, setLoadedDocuments] = useState<DocumentData[]>([])
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [openDeleteAll, setOpenDeleteAll] = useState<boolean>(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState<string>('');
  const [helperModalVisible, setHelperModalVisible] = useState<boolean>(false);
  const [isOpenSubscription, setIsOpenSubscription] = useState(false)


  async function fetchDocuments() {
    try {
      const data = await api("/get_documents")
      setLoadedDocuments(data)
    } catch (err: any) {
      console.log(err)
    }
      
  }
  useEffect(() => {
    fetchDocuments();
  }, [])
  const removeDocument = async(id: string) => {
    try {
      await api("/delete_document", {id: id})
      await fetchDocuments();
      setLoadedDocument({id: '', name: '', data: '', date: ''});
      showPopup("Sikeresen törölted a dokumentumot!", "success")
    } catch (err: any) {
      console.log(err)
    }
  };

  const removeAllDocuments = async () => {
    try {
      await api("/delete_all_document")

      setLoadedDocument({id: '', name: '', data: '', date: ''});
      await fetchDocuments();

      showPopup("Sikeresen törölted az összes dokumentumot!", "success");
    } catch (err: any) {
      console.error(err);
    }
  };


  return (
    <>
      <Header>
        <div id='documents-custom-header' className="flex items-center justify-center">
          <button id='left-part' className="flex mr-[68px]" onClick={() => navigate('/')}>
            <LeftArrowIcon className="h-5 w-5 mr-2 text-primaryAction fill-current" />
            <p className="text-gray150 text-style-small">Vissza a Főoldalra</p>       
          </button>
          <h2 id='documents-header-text' className="text-textMain text-style-h2">Dokumentumok</h2>
          <button id='dummy-element-for-spacing' className="invisible flex ml-[68px]">
            <LeftArrowIcon className="h-5 w-5 mr-2 text-primaryAction fill-current" />
            <p className="text-gray150 text-style-small">Vissza a Főoldalra</p>       
          </button>
        </div>
      </Header>
      <HelperModal isVisible={helperModalVisible} onClose={() => {setHelperModalVisible(false)}} modalContentType="documents" />
      {!helperModalVisible && (<HelperButton onClick={() => setHelperModalVisible(true)} />)}
      <DeleteDocumentModal isVisible={openDelete} onClose={() => setOpenDelete(false)} execute={() => removeDocument(selectedDocumentId)} />
      <DeleteAllDocumentModal isVisible={openDeleteAll} onClose={() => setOpenDeleteAll(false)} execute={removeAllDocuments} />
      <SubscriptionModal isVisible={isOpenSubscription} onClose={() => setIsOpenSubscription(false)} />
      <div className="flex flex-1 flex-col w-full bg-backgroundWhite overflow-y-auto no-scrollbar">
        <div id='separator' className="min-h-[86px] w-full"/>
        <main className="flex flex-1 flex-col w-full px-10 py-8 bg-backgroundWhite rounded-t-[16px]">
          <div id='documents-row' key={JSON.stringify(loadedDocuments)} className="flex flex-wrap gap-8 transform transition-all">
            {loadedDocuments.map((item, index) => (
              <DocumentCard
                key={index}
                item={item}
                open={() => {if (user.plan !== "standard") {setLoadedDocument(item); navigate('/edit')} else {setIsOpenSubscription(true)}}}
                download={() => {DocumentDownlaoder(item.name, item.data, showPopup)}}
                copy={() => {copyDocumentData(item.data, showPopup)}}
                _delete={() => {setSelectedDocumentId(item.id); setOpenDelete(true)}}
              />
            ))}
          </div>
          <div id='new-dorucment-row' className="pt-8" >
            <NewDocumentCard onClick={() => {if (user.plan !== "standard") {setLoadedDocument({id: '', name: '', data: '', date: ''}); navigate('/edit')} else {setIsOpenSubscription(true)}}} />      
          </div>
        </main>
        <div className="absolute bottom-6 right-6">
          <TertiaryGrayButton buttonInfo={{label: "Összes dokumentum törlése", buttonIcon: DeleteIcon }} onClick={() => setOpenDeleteAll(true)}/>
        </div>
      </div>
    </>
  )
}
